<template>
    <bottom-sheet v-model="shows" fullscreen persistent v-bind="{ title }" hide-foot>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <view-wrap :value="form" :key="key" />
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { initEmploymentContract } from "@/assets/variables";
import { mapMutations, mapState } from "vuex";

import BottomSheet from "@/components/console/dumb/bottom-sheet.vue";
import ViewWrap from "./view/view-wrap.vue";

export default {
    components: {
        BottomSheet,
        ViewWrap,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        value: { type: Object, default: initEmploymentContract },
    },
    data: () => ({
        shows: false,
        form: initEmploymentContract(),
    }),
    computed: {
        ...mapState("employment/form", ["loading"]),
        ...mapState("employment/form/page", ["key"]),

        title() {
            let title = "계약서 양식 보기";
            return title;
        },
    },
    methods: {
        ...mapMutations("employment/form", ["setForm", "setLoading"]),
        async init() {
            if (this.loading) return;
            else this.setLoading(true);
            try {
                let { contract } = await api.console.employment.contracts.get({ _id: this.value._id });
                this.form = initEmploymentContract(contract);
                this.$store.commit("employment/form/page/increaseKey");
            } finally {
                this.setLoading(false);
            }
        },
        exit() {
            this.shows = false;
        },
    },
    watch: {
        value() {
            if (this.shows) this.init();
            else this.$store.dispatch("employment/form/reset");
        },
        shows() {
            if (this.shows) this.init();
            else this.$store.dispatch("employment/form/reset");
        },
    },
};
</script>

<style lang="scss" scoped></style>
